// Canonical registry of javelin iterations (collection waves) — the ONE
// source of truth consumed by the worker (apps/api), the manager UI
// switchers (apps/internal: mobile mgr-project.ts + desktop lib.ts) and
// contract fixtures. Adding a wave = one entry here (+ flip CURRENT when
// it becomes active). See docs/javelin/ITERATIONS.md for the full map of
// everything an iteration touches.
//
// Keys are stable TEXT identifiers stored on participants / locations /
// javelin_transactions rows. Historical keys are range-shaped
// ('500', '500-1000'); from the third wave on the key is the wave's
// starting milestone ('1000') because wave sizes vary (next ~450).

export interface JavelinIteration {
  /** Stable DB key (participants.iteration etc). Never rename. */
  key: string;
  /** Long label — mobile manager project switcher. */
  label: string;
  /** Compact label — desktop cabinet segmented picker. */
  shortLabel: string;
}

export const JAVELIN_ITERATIONS: readonly JavelinIteration[] = [
  { key: '500',      label: 'Javelin 4 (500)',      shortLabel: '1–500' },
  { key: '500-1000', label: 'Javelin 4 (500-1000)', shortLabel: '500–1000' },
  { key: '1000',     label: 'Javelin 4 (1000)',     shortLabel: '1000+' },
];

/**
 * The active iteration: moderator-facing queries (cabinet, sessionState,
 * packs push, Участники) are scoped to it, and new homes/participants/
 * transactions are stamped with it. Third wave opened 2026-07-16 (LA):
 * every session filmed on/after that day belongs to '1000'.
 */
export const CURRENT_JAVELIN_ITERATION = '1000';

export const JAVELIN_ITERATION_KEYS: readonly string[] =
  JAVELIN_ITERATIONS.map(i => i.key);

export function isJavelinIteration(key: string): boolean {
  return JAVELIN_ITERATION_KEYS.includes(key);
}
